import { render } from "./ProjectFormCard.vue?vue&type=template&id=4c6b3e1e&scoped=true&ts=true"
import script from "./ProjectFormCard.vue?vue&type=script&lang=ts"
export * from "./ProjectFormCard.vue?vue&type=script&lang=ts"

import "./ProjectFormCard.vue?vue&type=style&index=0&id=4c6b3e1e&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6b3e1e"]])

export default __exports__